// extracted by mini-css-extract-plugin
export var banner = "_sa-0";
export var settingRow = "_sa-2";
export var titleIcon = "_sa-1";